module.exports = __webpack_public_path__ + "img/72000.9400436a.jpg";